<script>
import Layout from "../../layouts/main";
import draggable from 'vuedraggable';

export default {
  components: {
    Layout,
    draggable
  },
  data() {
  return {
    subcategorias: [],
    selectedSubcategoriaId: "",
    categoriaOrigen: null,
    productos: [],
    showPopup: false,
    isLoading: false, 
    originalOrden: [], 
  };
},

  methods: {
    fetchCategoria() {
  if (!this.selectedSubcategoriaId) return;
  this.isLoading = true; // ⏳ mostrar loading
  fetch(`https://humobarculinario.com/api/get_subcategory_by_id.php?subcategory_id=${this.selectedSubcategoriaId}`)
    .then(response => response.json())
    .then(data => {
      this.productos = data;
      this.originalOrden = data.map(p => p.id); 

    })
    .catch(error => {
      console.error("Error al obtener subcategorías:", error);
    })
    .finally(() => {
      this.isLoading = false; // ✅ ocultar loading
    });
},
guardarOrden() {
  this.isLoading = true;
  fetch("https://humobarculinario.com/api/guardar_orden_productos_post.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      subcategory_id: this.selectedSubcategoriaId,
      productos: this.productos.map(p => p.id)
    })
  })
  .then(res => res.json())
  .then(data => {
    console.log("Respuesta del backend:", data);
    alert("Orden guardado correctamente");
    this.originalOrden = this.productos.map(p => p.id); // ✅ Actualiza el orden original
  })
  .catch(error => {
    console.error("Error al guardar el orden:", error);
    alert("Ocurrió un error al guardar el orden");
  })
  .finally(() => {
    this.isLoading = false;
  });
}
  },
  mounted() {
    fetch("https://humobarculinario.com/api/subcategoria_get_all.php")
      .then(response => response.json())
      .then(data => {
        this.subcategorias = data;
      })
      .catch(error => {
        console.error("Error al obtener subcategorías:", error);
      });
  },
  computed: {
  hayCambios() {
    const ordenActual = this.productos.map(p => p.id);
    return JSON.stringify(ordenActual) !== JSON.stringify(this.originalOrden);
  }
}
};
</script>

<template>
  <Layout>
    <div v-if="isLoading" class="loading-overlay">
    <div class="loading-spinner"></div>
    </div>

    <div class="menu-container">
      <div class="header">
        <h5>ORDENAR PRODUCTOS</h5>
        <select v-model="selectedSubcategoriaId" class="search-input" @change="fetchCategoria">
          <option disabled value="">Selecciona una subcategoría</option>
          <option v-for="item in subcategorias" :key="item.id" :value="item.id">
            {{ item.name }}
          </option>
        </select>
        <button class="add-button" 
        @click="guardarOrden" 
        :disabled="!hayCambios || isLoading">
  <span v-if="isLoading">Guardando...</span>
  <span v-else>Guardar</span>
</button>
      </div>
      <table>
  <thead>
    <tr>
       <th style="width: 40px;"></th> <!-- Icono de mover -->
      <th style="width: 60px;">ID</th>
      <th style="width: 200px;">Nombre</th>
      <th style="width: 300px;">Descripción</th>
    </tr>
  </thead>
  <draggable v-model="productos" tag="tbody" handle=".handle">
    <tr v-for="producto in productos" :key="producto.id">
      <td class="handle" style="cursor: move;">☰</td>
      <td>{{ producto.id }}</td>
      <td>{{ producto.name }}</td>
      <td>{{ producto.description }}</td>
    </tr>
  </draggable>
</table>

    </div>
  </Layout>
</template>


<style scoped>
.menu-container {
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.search-input {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.add-button {
  background-color: purple;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
}
table {
  width: 100%;
  border-collapse: collapse;
}
th, td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
.available {
  color: green;
  font-weight: bold;
}
.sold-out {
  color: red;
  font-weight: bold;
}
.icon-button {
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 5px;
  font-size: 16px;
}
.pagination {
  margin-top: 10px;
  text-align: center;
}
.pagination button {
  margin: 2px;
  padding: 5px 10px;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;
}
.pagination .active {
  background: purple;
  color: white;
}
/* Cargando overlay y spinner */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.loading-spinner {
  border: 4px solid #f3f3f3; /* Fondo gris claro */
  border-top: 4px solid purple; /* Color de la parte que gira */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  width: 300px;
}
.popup label {
  display: block;
  margin-top: 10px;
  font-weight: bold;
}
.popup input, .popup select {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.popup-buttons {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
}
.add-button, .delete-button {
  background-color: #4e583c;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
}
.add-button:hover, .delete-button:hover {
  background-color: black;
}
.cancel-button {
  background-color: black;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
  border: 1px solid black;
}
.cancel-button:hover {
  background-color: white;
  border: 1px solid black;
  color: black;
}
.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4e583c; /* <- cambia esto */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}
</style>
